import * as React from 'react';
import { tag } from '../../../../model/tag';
import { StyledComponentProps, Typography, Grid } from '@material-ui/core';
import { Category } from '../../../../ui-components/Icons';
import { Table } from './table';

interface ITagItemProps extends StyledComponentProps {
    tag: tag;
    classes: any;
}

export const Followers = (props: ITagItemProps) => {
    const { classes, tag } = props;
    return (<Grid container>
        <Grid item xs={12} className={props.classes.followersHeader}>
            <Category style={{ fill: tag.color }} />
            <Typography style={{ color: tag.color}} className={classes.detailSampleText}>{tag.code} - {tag.description}</Typography>
        </Grid>
        <Table tag={tag} classes={classes} />
    </Grid>
    );
}